import { jsx } from "react/jsx-runtime";
import EventIcon from "@mui/icons-material/Event";
import { validateTidalLicense } from "../../base/index.js";
function Event(props) {
  return /* @__PURE__ */ jsx(
    EventIcon,
    {
      "data-testid": "Event",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Event",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Event.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Event"
};
validateTidalLicense();
export {
  Event
};
//# sourceMappingURL=Event.js.map
